import { useQuery } from "@tanstack/react-query";
import {
  getPlannerGlobalNotes,
  getPlannerTodos,
} from "../../sevices/apiPlannerTodos";
import { localStorageInstance } from "../localStorage";
export function usePlannerTodos() {
  const {
    isLoading,
    data: todos,
    error,
    isError,
  } = useQuery({
    queryKey: ["todos"],
    queryFn: getPlannerTodos,
    // enabled: !!localStorageInstance.getItem("planner_user_id"),
  });

  return { isLoading, error, todos, isError };
}

export function usePlannerGlobalNotes() {
  const {
    isLoading,
    data: globalNotes,
    error,
    isError,
  } = useQuery({
    queryKey: ["globalNotes"],
    queryFn: getPlannerGlobalNotes,
  });

  return { isLoading, error, globalNotes, isError };
}